import { DialogTitleProps, DialogTitle as MuiDialogTitle } from "@mui/material";

type Props = DialogTitleProps;

export const DialogTitle = ({ children, ...props }: Props) => {
  return <MuiDialogTitle {...props}>{children}</MuiDialogTitle>;
};
